module.exports = __webpack_public_path__ + "img/filledFile.50a9280f.svg";